import { useLocalStorage } from "@uidotdev/usehooks"

type ActiveProjectReturn = [
  activeProjectId: string | null,
  setActiveProjectId: (activeProjectId: string | null) => void,
]

const ACTIVE_PROJECT_KEY = "fieldbook.activeProject"

// taken from https://github.com/uidotdev/usehooks
// this enables us to use the localstorage imperatively as well as with the useLocalStorage hook
function dispatchStorageEvent(key: string, newValue: string | null) {
  window.dispatchEvent(new StorageEvent("storage", { key, newValue }))
}

const setLocalStorageItem = (key: string, value: string) => {
  const stringifiedValue = JSON.stringify(value)
  window.localStorage.setItem(key, stringifiedValue)
  dispatchStorageEvent(key, stringifiedValue)
}

const removeLocalStorageItem = (key: string) => {
  window.localStorage.removeItem(key)
  dispatchStorageEvent(key, null)
}

export const getActiveProject = () => {
  const activeProjectJson = localStorage.getItem(ACTIVE_PROJECT_KEY)
  const activeProject = activeProjectJson ? JSON.parse(activeProjectJson) : null
  return activeProject
}

export const setActiveProject = (activeProject: string | null) => {
  if (activeProject === null) removeLocalStorageItem(ACTIVE_PROJECT_KEY)
  else setLocalStorageItem(ACTIVE_PROJECT_KEY, activeProject)
}

export const useActiveProject = (): ActiveProjectReturn => {
  const [activeProjectId, setActiveProjectId] = useLocalStorage<string | null>(
    ACTIVE_PROJECT_KEY,
    undefined,
  )

  return [activeProjectId, setActiveProjectId]
}
